function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _asyncIterator(iterable) { var method; if (typeof Symbol !== "undefined") { if (Symbol.asyncIterator) method = iterable[Symbol.asyncIterator]; if (method == null && Symbol.iterator) method = iterable[Symbol.iterator]; } if (method == null) method = iterable["@@asyncIterator"]; if (method == null) method = iterable["@@iterator"]; if (method == null) throw new TypeError("Object is not async iterable"); return method.call(iterable); }

function _awaitAsyncGenerator(value) { return new _AwaitValue(value); }

function _wrapAsyncGenerator(fn) { return function () { return new _AsyncGenerator(fn.apply(this, arguments)); }; }

function _AsyncGenerator(gen) { var front, back; function send(key, arg) { return new Promise(function (resolve, reject) { var request = { key: key, arg: arg, resolve: resolve, reject: reject, next: null }; if (back) { back = back.next = request; } else { front = back = request; resume(key, arg); } }); } function resume(key, arg) { try { var result = gen[key](arg); var value = result.value; var wrappedAwait = value instanceof _AwaitValue; Promise.resolve(wrappedAwait ? value.wrapped : value).then(function (arg) { if (wrappedAwait) { resume(key === "return" ? "return" : "next", arg); return; } settle(result.done ? "return" : "normal", arg); }, function (err) { resume("throw", err); }); } catch (err) { settle("throw", err); } } function settle(type, value) { switch (type) { case "return": front.resolve({ value: value, done: true }); break; case "throw": front.reject(value); break; default: front.resolve({ value: value, done: false }); break; } front = front.next; if (front) { resume(front.key, front.arg); } else { back = null; } } this._invoke = send; if (typeof gen.return !== "function") { this.return = undefined; } }

_AsyncGenerator.prototype[typeof Symbol === "function" && Symbol.asyncIterator || "@@asyncIterator"] = function () { return this; };

_AsyncGenerator.prototype.next = function (arg) { return this._invoke("next", arg); };

_AsyncGenerator.prototype.throw = function (arg) { return this._invoke("throw", arg); };

_AsyncGenerator.prototype.return = function (arg) { return this._invoke("return", arg); };

function _AwaitValue(value) { this.wrapped = value; }

import { isArqueroTable } from "./arquero.js";
import { getArrowTableSchema, isArrowTable, loadArrow } from "./arrow.js";
import { duckdb } from "./dependencies.js";
import { FileAttachment } from "./fileAttachment.js";
import { cdn } from "./require.js"; // Adapted from https://observablehq.com/@cmudig/duckdb-client
// Copyright 2021 CMU Data Interaction Group
//
// Redistribution and use in source and binary forms, with or without
// modification, are permitted provided that the following conditions are met:
//
// 1. Redistributions of source code must retain the above copyright notice,
//    this list of conditions and the following disclaimer.
//
// 2. Redistributions in binary form must reproduce the above copyright notice,
//    this list of conditions and the following disclaimer in the documentation
//    and/or other materials provided with the distribution.
//
// 3. Neither the name of the copyright holder nor the names of its contributors
//    may be used to endorse or promote products derived from this software
//    without specific prior written permission.
//
// THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
// AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
// IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
// ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
// LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
// CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
// SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
// INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
// CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
// ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
// POSSIBILITY OF SUCH DAMAGE.

var promise;
export var DuckDBClient = /*#__PURE__*/function () {
  function DuckDBClient(db) {
    _classCallCheck(this, DuckDBClient);

    Object.defineProperties(this, {
      _db: {
        value: db
      }
    });
  }

  _createClass(DuckDBClient, [{
    key: "queryStream",
    value: function () {
      var _queryStream = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(query, params) {
        var connection, reader, batch, statement;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this._db.connect();

              case 2:
                connection = _context2.sent;
                _context2.prev = 3;

                if (!((params === null || params === void 0 ? void 0 : params.length) > 0)) {
                  _context2.next = 13;
                  break;
                }

                _context2.next = 7;
                return connection.prepare(query);

              case 7:
                statement = _context2.sent;
                _context2.next = 10;
                return statement.send.apply(statement, _toConsumableArray(params));

              case 10:
                reader = _context2.sent;
                _context2.next = 16;
                break;

              case 13:
                _context2.next = 15;
                return connection.send(query);

              case 15:
                reader = _context2.sent;

              case 16:
                _context2.next = 18;
                return reader.next();

              case 18:
                batch = _context2.sent;

                if (!batch.done) {
                  _context2.next = 21;
                  break;
                }

                throw new Error("missing first batch");

              case 21:
                _context2.next = 28;
                break;

              case 23:
                _context2.prev = 23;
                _context2.t0 = _context2["catch"](3);
                _context2.next = 27;
                return connection.close();

              case 27:
                throw _context2.t0;

              case 28:
                return _context2.abrupt("return", {
                  schema: getArrowTableSchema(batch.value),
                  readRows: function readRows() {
                    return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                      return _regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              _context.prev = 0;

                            case 1:
                              if (batch.done) {
                                _context.next = 9;
                                break;
                              }

                              _context.next = 4;
                              return batch.value.toArray();

                            case 4:
                              _context.next = 6;
                              return _awaitAsyncGenerator(reader.next());

                            case 6:
                              batch = _context.sent;
                              _context.next = 1;
                              break;

                            case 9:
                              _context.prev = 9;
                              _context.next = 12;
                              return _awaitAsyncGenerator(connection.close());

                            case 12:
                              return _context.finish(9);

                            case 13:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee, null, [[0,, 9, 13]]);
                    }))();
                  }
                });

              case 29:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[3, 23]]);
      }));

      function queryStream(_x, _x2) {
        return _queryStream.apply(this, arguments);
      }

      return queryStream;
    }()
  }, {
    key: "query",
    value: function () {
      var _query2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_query, params) {
        var result, results, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, rows, _iterator2, _step2, row;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.queryStream(_query, params);

              case 2:
                result = _context3.sent;
                results = [];
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _context3.prev = 6;
                _iterator = _asyncIterator(result.readRows());

              case 8:
                _context3.next = 10;
                return _iterator.next();

              case 10:
                _step = _context3.sent;
                _iteratorNormalCompletion = _step.done;
                _context3.next = 14;
                return _step.value;

              case 14:
                _value = _context3.sent;

                if (_iteratorNormalCompletion) {
                  _context3.next = 22;
                  break;
                }

                rows = _value;
                _iterator2 = _createForOfIteratorHelper(rows);

                try {
                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                    row = _step2.value;
                    results.push(row);
                  }
                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }

              case 19:
                _iteratorNormalCompletion = true;
                _context3.next = 8;
                break;

              case 22:
                _context3.next = 28;
                break;

              case 24:
                _context3.prev = 24;
                _context3.t0 = _context3["catch"](6);
                _didIteratorError = true;
                _iteratorError = _context3.t0;

              case 28:
                _context3.prev = 28;
                _context3.prev = 29;

                if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                  _context3.next = 33;
                  break;
                }

                _context3.next = 33;
                return _iterator.return();

              case 33:
                _context3.prev = 33;

                if (!_didIteratorError) {
                  _context3.next = 36;
                  break;
                }

                throw _iteratorError;

              case 36:
                return _context3.finish(33);

              case 37:
                return _context3.finish(28);

              case 38:
                results.schema = result.schema;
                return _context3.abrupt("return", results);

              case 40:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[6, 24, 28, 38], [29,, 33, 37]]);
      }));

      function query(_x3, _x4) {
        return _query2.apply(this, arguments);
      }

      return query;
    }()
  }, {
    key: "queryRow",
    value: function () {
      var _queryRow = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(query, params) {
        var result, reader, _yield$reader$next, done, value;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.queryStream(query, params);

              case 2:
                result = _context4.sent;
                reader = result.readRows();
                _context4.prev = 4;
                _context4.next = 7;
                return reader.next();

              case 7:
                _yield$reader$next = _context4.sent;
                done = _yield$reader$next.done;
                value = _yield$reader$next.value;
                return _context4.abrupt("return", done || !value.length ? null : value[0]);

              case 11:
                _context4.prev = 11;
                _context4.next = 14;
                return reader.return();

              case 14:
                return _context4.finish(11);

              case 15:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[4,, 11, 15]]);
      }));

      function queryRow(_x5, _x6) {
        return _queryRow.apply(this, arguments);
      }

      return queryRow;
    }()
  }, {
    key: "sql",
    value: function () {
      var _sql = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(strings) {
        var _len,
            args,
            _key,
            _args5 = arguments;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                for (_len = _args5.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                  args[_key - 1] = _args5[_key];
                }

                _context5.next = 3;
                return this.query(strings.join("?"), args);

              case 3:
                return _context5.abrupt("return", _context5.sent);

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function sql(_x7) {
        return _sql.apply(this, arguments);
      }

      return sql;
    }()
  }, {
    key: "queryTag",
    value: function queryTag(strings) {
      for (var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        params[_key2 - 1] = arguments[_key2];
      }

      return [strings.join("?"), params];
    }
  }, {
    key: "escape",
    value: function escape(name) {
      return "\"".concat(name, "\"");
    }
  }, {
    key: "describeTables",
    value: function () {
      var _describeTables = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var tables;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.query("SHOW TABLES");

              case 2:
                tables = _context6.sent;
                return _context6.abrupt("return", tables.map(function (_ref) {
                  var name = _ref.name;
                  return {
                    name: name
                  };
                }));

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function describeTables() {
        return _describeTables.apply(this, arguments);
      }

      return describeTables;
    }()
  }, {
    key: "describeColumns",
    value: function () {
      var _describeColumns = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var _ref2,
            table,
            columns,
            _args7 = arguments;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _ref2 = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : {}, table = _ref2.table;
                _context7.next = 3;
                return this.query("DESCRIBE ".concat(this.escape(table)));

              case 3:
                columns = _context7.sent;
                return _context7.abrupt("return", columns.map(function (_ref3) {
                  var column_name = _ref3.column_name,
                      column_type = _ref3.column_type,
                      nullable = _ref3.null;
                  return {
                    name: column_name,
                    type: getDuckDBType(column_type),
                    nullable: nullable !== "NO",
                    databaseType: column_type
                  };
                }));

              case 5:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function describeColumns() {
        return _describeColumns.apply(this, arguments);
      }

      return describeColumns;
    }()
  }], [{
    key: "of",
    value: function () {
      var _of = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var _config$query, _config$query2;

        var sources,
            config,
            db,
            _args9 = arguments;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                sources = _args9.length > 0 && _args9[0] !== undefined ? _args9[0] : {};
                config = _args9.length > 1 && _args9[1] !== undefined ? _args9[1] : {};
                _context9.next = 4;
                return createDuckDB();

              case 4:
                db = _context9.sent;

                if (((_config$query = config.query) === null || _config$query === void 0 ? void 0 : _config$query.castTimestampToDate) === undefined) {
                  config = _objectSpread(_objectSpread({}, config), {}, {
                    query: _objectSpread(_objectSpread({}, config.query), {}, {
                      castTimestampToDate: true
                    })
                  });
                }

                if (((_config$query2 = config.query) === null || _config$query2 === void 0 ? void 0 : _config$query2.castBigIntToDouble) === undefined) {
                  config = _objectSpread(_objectSpread({}, config), {}, {
                    query: _objectSpread(_objectSpread({}, config.query), {}, {
                      castBigIntToDouble: true
                    })
                  });
                }

                _context9.next = 9;
                return db.open(config);

              case 9:
                _context9.next = 11;
                return Promise.all(Object.entries(sources).map( /*#__PURE__*/function () {
                  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(_ref4) {
                    var _ref6, name, source, data, options, file, _options;

                    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                      while (1) {
                        switch (_context8.prev = _context8.next) {
                          case 0:
                            _ref6 = _slicedToArray(_ref4, 2), name = _ref6[0], source = _ref6[1];

                            if (!(source instanceof FileAttachment)) {
                              _context8.next = 6;
                              break;
                            }

                            _context8.next = 4;
                            return insertFile(db, name, source);

                          case 4:
                            _context8.next = 39;
                            break;

                          case 6:
                            if (!isArrowTable(source)) {
                              _context8.next = 11;
                              break;
                            }

                            _context8.next = 9;
                            return insertArrowTable(db, name, source);

                          case 9:
                            _context8.next = 39;
                            break;

                          case 11:
                            if (!Array.isArray(source)) {
                              _context8.next = 16;
                              break;
                            }

                            _context8.next = 14;
                            return insertArray(db, name, source);

                          case 14:
                            _context8.next = 39;
                            break;

                          case 16:
                            if (!isArqueroTable(source)) {
                              _context8.next = 21;
                              break;
                            }

                            _context8.next = 19;
                            return insertArqueroTable(db, name, source);

                          case 19:
                            _context8.next = 39;
                            break;

                          case 21:
                            if (!("data" in source)) {
                              _context8.next = 32;
                              break;
                            }

                            // data + options
                            data = source.data, options = _objectWithoutProperties(source, ["data"]);

                            if (!isArrowTable(data)) {
                              _context8.next = 28;
                              break;
                            }

                            _context8.next = 26;
                            return insertArrowTable(db, name, data, options);

                          case 26:
                            _context8.next = 30;
                            break;

                          case 28:
                            _context8.next = 30;
                            return insertArray(db, name, data, options);

                          case 30:
                            _context8.next = 39;
                            break;

                          case 32:
                            if (!("file" in source)) {
                              _context8.next = 38;
                              break;
                            }

                            // file + options
                            file = source.file, _options = _objectWithoutProperties(source, ["file"]);
                            _context8.next = 36;
                            return insertFile(db, name, file, _options);

                          case 36:
                            _context8.next = 39;
                            break;

                          case 38:
                            throw new Error("invalid source: ".concat(source));

                          case 39:
                          case "end":
                            return _context8.stop();
                        }
                      }
                    }, _callee8);
                  }));

                  return function (_x8) {
                    return _ref5.apply(this, arguments);
                  };
                }()));

              case 11:
                return _context9.abrupt("return", new DuckDBClient(db));

              case 12:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      function of() {
        return _of.apply(this, arguments);
      }

      return of;
    }()
  }]);

  return DuckDBClient;
}();
Object.defineProperty(DuckDBClient.prototype, "dialect", {
  value: "duckdb"
});

function insertFile(_x9, _x10, _x11, _x12) {
  return _insertFile.apply(this, arguments);
}

function _insertFile() {
  _insertFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(database, name, file, options) {
    var url, buffer, connection, _buffer;

    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            _context11.next = 2;
            return file.url();

          case 2:
            url = _context11.sent;

            if (!url.startsWith("blob:")) {
              _context11.next = 11;
              break;
            }

            _context11.next = 6;
            return file.arrayBuffer();

          case 6:
            buffer = _context11.sent;
            _context11.next = 9;
            return database.registerFileBuffer(file.name, new Uint8Array(buffer));

          case 9:
            _context11.next = 13;
            break;

          case 11:
            _context11.next = 13;
            return database.registerFileURL(file.name, url, 4);

          case 13:
            _context11.next = 15;
            return database.connect();

          case 15:
            connection = _context11.sent;
            _context11.prev = 16;
            _context11.t0 = file.mimeType;
            _context11.next = _context11.t0 === "text/csv" ? 20 : _context11.t0 === "text/tab-separated-values" ? 20 : _context11.t0 === "application/json" ? 23 : 26;
            break;

          case 20:
            _context11.next = 22;
            return connection.insertCSVFromPath(file.name, _objectSpread({
              name: name,
              schema: "main"
            }, options)).catch( /*#__PURE__*/function () {
              var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(error) {
                return _regeneratorRuntime.wrap(function _callee10$(_context10) {
                  while (1) {
                    switch (_context10.prev = _context10.next) {
                      case 0:
                        if (!error.toString().includes("Could not convert")) {
                          _context10.next = 4;
                          break;
                        }

                        _context10.next = 3;
                        return insertUntypedCSV(connection, file, name);

                      case 3:
                        return _context10.abrupt("return", _context10.sent);

                      case 4:
                        throw error;

                      case 5:
                      case "end":
                        return _context10.stop();
                    }
                  }
                }, _callee10);
              }));

              return function (_x27) {
                return _ref7.apply(this, arguments);
              };
            }());

          case 22:
            return _context11.abrupt("return", _context11.sent);

          case 23:
            _context11.next = 25;
            return connection.insertJSONFromPath(file.name, _objectSpread({
              name: name,
              schema: "main"
            }, options));

          case 25:
            return _context11.abrupt("return", _context11.sent);

          case 26:
            if (!/\.arrow$/i.test(file.name)) {
              _context11.next = 35;
              break;
            }

            _context11.t1 = Uint8Array;
            _context11.next = 30;
            return file.arrayBuffer();

          case 30:
            _context11.t2 = _context11.sent;
            _buffer = new _context11.t1(_context11.t2);
            _context11.next = 34;
            return connection.insertArrowFromIPCStream(_buffer, _objectSpread({
              name: name,
              schema: "main"
            }, options));

          case 34:
            return _context11.abrupt("return", _context11.sent);

          case 35:
            if (!/\.parquet$/i.test(file.name)) {
              _context11.next = 39;
              break;
            }

            _context11.next = 38;
            return connection.query("CREATE VIEW '".concat(name, "' AS SELECT * FROM parquet_scan('").concat(file.name, "')"));

          case 38:
            return _context11.abrupt("return", _context11.sent);

          case 39:
            throw new Error("unknown file type: ".concat(file.mimeType));

          case 40:
            _context11.prev = 40;
            _context11.next = 43;
            return connection.close();

          case 43:
            return _context11.finish(40);

          case 44:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11, null, [[16,, 40, 44]]);
  }));
  return _insertFile.apply(this, arguments);
}

function insertUntypedCSV(_x13, _x14, _x15) {
  return _insertUntypedCSV.apply(this, arguments);
}

function _insertUntypedCSV() {
  _insertUntypedCSV = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(connection, file, name) {
    var statement;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            _context12.next = 2;
            return connection.prepare("CREATE TABLE '".concat(name, "' AS SELECT * FROM read_csv_auto(?, ALL_VARCHAR=TRUE)"));

          case 2:
            statement = _context12.sent;
            _context12.next = 5;
            return statement.send(file.name);

          case 5:
            return _context12.abrupt("return", _context12.sent);

          case 6:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));
  return _insertUntypedCSV.apply(this, arguments);
}

function insertArrowTable(_x16, _x17, _x18, _x19) {
  return _insertArrowTable.apply(this, arguments);
}

function _insertArrowTable() {
  _insertArrowTable = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(database, name, table, options) {
    var connection;
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            _context13.next = 2;
            return database.connect();

          case 2:
            connection = _context13.sent;
            _context13.prev = 3;
            _context13.next = 6;
            return connection.insertArrowTable(table, _objectSpread({
              name: name,
              schema: "main"
            }, options));

          case 6:
            _context13.prev = 6;
            _context13.next = 9;
            return connection.close();

          case 9:
            return _context13.finish(6);

          case 10:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13, null, [[3,, 6, 10]]);
  }));
  return _insertArrowTable.apply(this, arguments);
}

function insertArqueroTable(_x20, _x21, _x22) {
  return _insertArqueroTable.apply(this, arguments);
}

function _insertArqueroTable() {
  _insertArqueroTable = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(database, name, source) {
    var arrow, table;
    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            _context14.next = 2;
            return loadArrow();

          case 2:
            arrow = _context14.sent;
            table = arrow.tableFromIPC(source.toArrowBuffer());
            _context14.next = 6;
            return insertArrowTable(database, name, table);

          case 6:
            return _context14.abrupt("return", _context14.sent);

          case 7:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  }));
  return _insertArqueroTable.apply(this, arguments);
}

function insertArray(_x23, _x24, _x25, _x26) {
  return _insertArray.apply(this, arguments);
}

function _insertArray() {
  _insertArray = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(database, name, array, options) {
    var arrow, table;
    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            _context15.next = 2;
            return loadArrow();

          case 2:
            arrow = _context15.sent;
            table = arrow.tableFromJSON(array);
            _context15.next = 6;
            return insertArrowTable(database, name, table, options);

          case 6:
            return _context15.abrupt("return", _context15.sent);

          case 7:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  }));
  return _insertArray.apply(this, arguments);
}

function loadDuckDB() {
  return _loadDuckDB.apply(this, arguments);
}

function _loadDuckDB() {
  _loadDuckDB = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
    var module, bundle, logger;
    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            _context16.next = 2;
            return import("".concat(cdn).concat(duckdb.resolve()));

          case 2:
            module = _context16.sent;
            _context16.next = 5;
            return module.selectBundle({
              mvp: {
                mainModule: "".concat(cdn).concat(duckdb.resolve("dist/duckdb-mvp.wasm")),
                mainWorker: "".concat(cdn).concat(duckdb.resolve("dist/duckdb-browser-mvp.worker.js"))
              },
              eh: {
                mainModule: "".concat(cdn).concat(duckdb.resolve("dist/duckdb-eh.wasm")),
                mainWorker: "".concat(cdn).concat(duckdb.resolve("dist/duckdb-browser-eh.worker.js"))
              }
            });

          case 5:
            bundle = _context16.sent;
            logger = new module.ConsoleLogger();
            return _context16.abrupt("return", {
              module: module,
              bundle: bundle,
              logger: logger
            });

          case 8:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16);
  }));
  return _loadDuckDB.apply(this, arguments);
}

function createDuckDB() {
  return _createDuckDB.apply(this, arguments);
} // https://duckdb.org/docs/sql/data_types/overview


function _createDuckDB() {
  _createDuckDB = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
    var _yield$promise, module, bundle, logger, worker, db;

    return _regeneratorRuntime.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            if (promise === undefined) promise = loadDuckDB();
            _context17.next = 3;
            return promise;

          case 3:
            _yield$promise = _context17.sent;
            module = _yield$promise.module;
            bundle = _yield$promise.bundle;
            logger = _yield$promise.logger;
            _context17.next = 9;
            return module.createWorker(bundle.mainWorker);

          case 9:
            worker = _context17.sent;
            db = new module.AsyncDuckDB(logger, worker);
            _context17.next = 13;
            return db.instantiate(bundle.mainModule);

          case 13:
            return _context17.abrupt("return", db);

          case 14:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17);
  }));
  return _createDuckDB.apply(this, arguments);
}

function getDuckDBType(type) {
  switch (type) {
    case "BIGINT":
    case "HUGEINT":
    case "UBIGINT":
      return "bigint";

    case "DOUBLE":
    case "REAL":
    case "FLOAT":
      return "number";

    case "INTEGER":
    case "SMALLINT":
    case "TINYINT":
    case "USMALLINT":
    case "UINTEGER":
    case "UTINYINT":
      return "integer";

    case "BOOLEAN":
      return "boolean";

    case "DATE":
    case "TIMESTAMP":
    case "TIMESTAMP WITH TIME ZONE":
      return "date";

    case "VARCHAR":
    case "UUID":
      return "string";
    // case "BLOB":
    // case "INTERVAL":
    // case "TIME":

    default:
      if (/^DECIMAL\(/.test(type)) return "integer";
      return "other";
  }
}